import { saveMeta } from 'communicator/store';
import { getIsVisaSRCi, getOrgId, getSessionId } from 'communicator/store/selectors';
import { fetchRevokeAllTokens } from './api/collection';
import fetchRevoke from './api/revoke';
import { deleteSsiErmCookies } from './cookies';
import { markEnd, markStart } from './instrumentation';
import createSessionId from './session-id';
import { loadThm } from './thm';

type UnbindOptions = {
  accessToken?: string;
  idTokens?: string[];
  ignoreAccessToken?: boolean;
  recognitionToken?: string[];
  marks?: {
    collection: string;
    revoke: string;
  };
};

export default async function unbind(data: UnbindOptions) {
  // VCO-14997 - After unbind, we must relaunch THM with a new sessionId

  saveMeta({
    sessionId: createSessionId(),
    thmProfileHint: null
  });

  loadThm({
    orgId: getOrgId(),
    sessionId: getSessionId(),
    isVisaSrci: getIsVisaSRCi()
  });

  if (data.accessToken) {
    if (data.marks?.collection) {
      markStart(data.marks.collection);
    }

    if (data.marks?.revoke) {
      markStart(data.marks.revoke);
    }

    await Promise.all([
      fetchRevokeAllTokens({
        accessToken: data.accessToken,
        // TODO: do we need to keep track of all idTokens passed into
        // getSrcProfile and revoke them here?
        idTokens: data.idTokens ?? [],
        ignoreAccessToken: data.ignoreAccessToken,
        recognitionToken: data.recognitionToken ?? []
      }).then(() => {
        if (data.marks?.collection) {
          markEnd(data.marks.collection);
        }
      }),
      // TODO: is this necessary since remember_me is included in revokeAllTokens?
      fetchRevoke({
        accessToken: data.accessToken,
        type: 'remember_me'
      }).then(() => {
        if (data.marks?.revoke) {
          markEnd(data.marks.revoke);
        }
      })
    ]);

    if (!data.ignoreAccessToken) {
      // TODO: is this necessary since access_token is included in revokeAllTokens?
      // Revoke access token at the end
      fetchRevoke({
        accessToken: data.accessToken,
        type: 'access_token'
      });
    }

    saveMeta({ vIntentId: undefined });
  }

  deleteSsiErmCookies();
}
